import { RootState } from '@/store'
import { Alert, Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'
import { previousStep } from '@/slices/creator'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export interface CreatorButtonsProps {
    nextStepActive: boolean
    previousStepActive: boolean
    isFirst: boolean
    isLast: boolean
    skipActive: boolean
    handleNext: () => void
}

const useStyles = makeStyles()((theme) => ({
    buttons: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
    },
    nextStepButton: {
        marginLeft: 'auto',
    },
    belowButtons: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    skipButton: {
        color: theme.palette.text.primary,
        fontSize: '0.8rem',
    },
    finish: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

export const CreatorButtons = (props: CreatorButtonsProps) => {
    const { nextStepActive, skipActive, previousStepActive, isFirst, isLast, handleNext } = props
    const { classes } = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleClickNext = () => {
        handleNext()
    }

    const handleSkip = () => {
        navigate('/')
    }

    const activeStepIndex = useSelector((state: RootState) => state.creator.activeStepIndex)
    const creatorError = useSelector((state: RootState) => state.creator.error)
    const dispatch = useDispatch()

    return (
        <>
            {creatorError.error && <Alert severity="error">{creatorError.message}</Alert>}
            <Box className={classes.buttons}>
                {activeStepIndex !== 0 && !isFirst && (
                    <Button
                        variant="contained"
                        tabIndex={2}
                        color="inherit"
                        disabled={!previousStepActive}
                        onClick={() => dispatch(previousStep())}
                        sx={{ mr: 1 }}
                    >
                        {t('steps.previousStep')}
                    </Button>
                )}
                <Button className={classes.nextStepButton} variant="contained" onClick={handleClickNext} disabled={!nextStepActive}>
                    {isLast ? t('steps.finish') : t('steps.nextStep')}
                </Button>
            </Box>
            {skipActive && (
                <Box className={classes.belowButtons}>
                    <Button tabIndex={1} className={classes.skipButton} onClick={handleSkip}>
                        {t('steps.skip')}
                    </Button>
                </Box>
            )}
        </>
    )
}
